<template>
    <v-dialog v-model="isActive" persistent width="300" :overlay-color="`#000`" overlay-opacity="0.5">
      <v-card color="dark" dark>
        <v-card-text>Processing...Please wait
        	<v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
</template>

<script>
export default {
  name: 'ProcessLoader',
  props: {
    isActive: {
      type: Boolean,
      required: true
    }
  }
}
</script>

<style scoped>
.v-card__text {
	padding-top: 15px !important;
}
</style>
